import {
  FETCH_ADD_PROJECT_TEMPLATE_TASK_REQUEST,
  FETCH_ADD_PROJECT_TEMPLATE_TASK_SUCCESS,
  FETCH_ADD_PROJECT_TEMPLATE_TASK_FALUIRE,
} from './addProjectTemplateTaskTypes'

const initialState = {
  loading: false,
  addProjectTemplateTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ADD_PROJECT_TEMPLATE_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_ADD_PROJECT_TEMPLATE_TASK_SUCCESS : return {
      ...state,
      addProjectTemplateTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_ADD_PROJECT_TEMPLATE_TASK_FALUIRE : return {
      ...state,
      loading: false,
      addProjectTemplateTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
